import { gql } from '@apollo/client';

export const ALL_STAKEHOLDER_PHASES = gql`
  query AllStakeholderPhases {
    stakeholderPhases: getStakeholderPhases {
      id
      name
    }
  }
`;
